module.exports = new __parcel__URL__("onedrive@2x.f4a93cda.png").toString();